import {CircularProgress, makeStyles} from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 'auto',
    overflow: 'hidden'
  },
}));

export interface LoadingProps
{
  isLoading: boolean;
  children?: React.ReactNode;
}

export default function Loading(props: LoadingProps) {
  const {isLoading, children} = props;
  const classes = useStyles();

  return (
      <>
        {isLoading && (
            <div className={classes.root}>
              <CircularProgress />
            </div>
        )}
        {!isLoading && (
            <>
              {children}
            </>
        )}
      </>
  )
}